const Config: {
  appVersion: string
  avatarBucketName: string
  emulatorHost: string
  environment: string
  firebaseApiKey: string
  firebaseAppId: string
  firebaseAuthDomain: string
  firebaseDatabaseUrl: string
  firebaseMeasurementId: string
  firebaseMessagingSenderId: string
  firebaseProjectId: string
  firebaseStorageBucket: string
  firebaseVapidKey: string
  branchKeyLive: string
  filesBucketName: string
  isProduction: boolean
  useEmulators: boolean
  firebaseFunctionSecureProxies: Record<
    string,
    {
      proxyUrl: string
      headers?: Record<string, string>
    } | null
  >
  slackCommunityInviteLink: string
  appDocumentationLink: string
  appGetHelpLink: string
  intercomAppId: string
  sentryDsn: string
  stripePublicKey: string
  stripeSubscriptionLaunchDate: string
  stripeDefaultTrialPeriodDays: number
  stripeTrialPeriodEarlyPaymentMethodCredit: number
} = {
  // Vite configs
  firebaseApiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  firebaseAppId: import.meta.env.VITE_FIREBASE_APP_ID,
  firebaseAuthDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  firebaseDatabaseUrl: import.meta.env.VITE_FIREBASE_DATABASE_URL,
  firebaseMeasurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
  firebaseMessagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  firebaseProjectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  firebaseStorageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  firebaseVapidKey: import.meta.env.VITE_FIREBASE_VAPID_KEY,
  branchKeyLive: import.meta.env.VITE_BRANCH_KEY_LIVE,

  // App version information
  appVersion: __APP_VERSION__,

  // This is the avatar bucket URL that we want to upload for storage
  avatarBucketName: import.meta.env.VITE_AVATAR_BUCKET_NAME,

  // The files bucket URL that we want to upload for storage
  filesBucketName: import.meta.env.VITE_FILES_BUCKET_NAME,

  // This is the host we'll attempt to connect to when using the emulators
  // If you are running on a physical device, replace localhost with the local IP of your PC (192.168.x.x)
  emulatorHost: import.meta.env.VITE_EMULATOR_HOST,

  // This is the environment we're building for
  environment: import.meta.env.MODE,

  // Check if we're in production
  isProduction: import.meta.env.MODE === "production",

  // Do we want to use the local emulators or use the actual environment
  useEmulators: import.meta.env.VITE_USE_EMULATORS === "true",

  firebaseFunctionSecureProxies: {
    billingSaveCreditCard: {
      proxyUrl: import.meta.env.VITE_BILLING_SAVE_CREDIT_CARD_PROXY_URL,
      headers: {
        "BT-PROXY-KEY": import.meta.env.VITE_BILLING_SAVE_CREDIT_CARD_PROXY_KEY,
      },
    },
    billingRevealCreditCard: {
      proxyUrl: import.meta.env.VITE_BILLING_REVEAL_CREDIT_CARD_PROXY_URL,
      headers: {
        "BT-PROXY-KEY": import.meta.env.VITE_BILLING_REVEAL_CREDIT_CARD_PROXY_KEY,
      },
    },
    saveProfile: {
      proxyUrl: import.meta.env.VITE_SAVE_PROFILE_PROXY_URL,
      headers: {
        "BT-PROXY-KEY": import.meta.env.VITE_SAVE_PROFILE_PROXY_KEY,
      },
    },
    revealPassportNumber: {
      proxyUrl: import.meta.env.VITE_REVEAL_PASSPORT_NUMBER_PROXY_URL,
      headers: {
        "BT-PROXY-KEY": import.meta.env.VITE_REVEAL_PASSPORT_NUMBER_PROXY_KEY,
      },
    },
  },
  slackCommunityInviteLink: import.meta.env.VITE_SLACK_COMMUNITY_INVITE_LINK,
  appDocumentationLink: import.meta.env.VITE_APP_DOCUMENTATION_LINK,
  appGetHelpLink: import.meta.env.VITE_APP_GET_HELP_LINK,
  intercomAppId: import.meta.env.VITE_INTERCOM_APP_ID,
  sentryDsn: import.meta.env.VITE_SENTRY_DSN,
  stripePublicKey: import.meta.env.VITE_STRIPE_PUBLIC_KEY,
  stripeSubscriptionLaunchDate: import.meta.env.VITE_STRIPE_SUBSCRIPT_LAUNCH_DATE,
  stripeDefaultTrialPeriodDays: 14,
  stripeTrialPeriodEarlyPaymentMethodCredit: 1000, // $10.00 if in USD
}

export default Config
